import { Button } from '@e2n/ui';
import { useRotationsplanFeatureContext } from '@/domain/mitarbeiter/features/rotationsplan/features/shared/RotationsplanFeatureContext';
import {
  faArrowDownShortWide,
  faArrowUpShortWide,
} from '@fortawesome/pro-regular-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { useTranslation } from 'react-i18next';

export function SortierungButton() {
  const { t } = useTranslation();
  const {
    store: {
      ui: {
        kalender: { istSortierungAufsteigend },
      },
      setKalenderSortierung,
    },
  } = useRotationsplanFeatureContext();

  function changeSortierung() {
    setKalenderSortierung(!istSortierungAufsteigend);
  }

  return (
    <Button
      className="flex items-center gap-2 w-fit"
      variant="ghost"
      onClick={changeSortierung}>
      <FontAwesomeIcon
        icon={
          istSortierungAufsteigend ? faArrowDownShortWide : faArrowUpShortWide
        }
      />
      <div className="hidden md:flex">
        {t('domain.mitarbeiter.rotationsplan.sortierung')}
      </div>
    </Button>
  );
}
